import { render } from "./NivvoEmbed.vue?vue&type=template&id=5a174c62&scoped=true"
import script from "./NivvoEmbed.vue?vue&type=script&lang=js"
export * from "./NivvoEmbed.vue?vue&type=script&lang=js"

import "./NivvoEmbed.vue?vue&type=style&index=0&id=5a174c62&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a174c62"]])

export default __exports__